import { createContext, useContext, useState } from "react";

const ConsultationContext = createContext(null);

export const ConsultationProvider = ({ children }) => {
  const [open, setOpen] = useState(false);
  return (
    <ConsultationContext.Provider value={{ open, setOpen }}>
      {children}
    </ConsultationContext.Provider>
  );
};

export const useConsultation = () => useContext(ConsultationContext);
